// src/layouts/ExpertSection/ExpertSection.js

import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import scrollTo from "gatsby-plugin-smoothscroll"
import { Link } from "gatsby"

const ExpertSection = ({ expertSectionTopContent, expertTeamMembers }) => {
  return (
    <BlockContent>
      <div className="element-border">
        <div
          className="top-content"
          dangerouslySetInnerHTML={{ __html: expertSectionTopContent }}
        />
        <div className="team-map">
          {expertTeamMembers.map(teamMember => {
            return (
              <div class="team-col">
                <GatsbyImage
                  image={
                    teamMember.featuredImage.node.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  alt={teamMember.title}
                />
                <h3>{teamMember.title}</h3>
                <p>{teamMember.TeamMemberJobTitle.tmJobTitle}</p>
              </div>
            )
          })}
        </div>
        <div class="button-cta">
          <button>
            <Link to="/contact/">Talk to our Experts</Link>
          </button>
        </div>
      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 1210px;
  width: 100%;
  margin: 50px auto;
  padding: 0 20px;
  .element-border {
    padding: 70px 100px;
    border: 5px solid #ebebeb;
  }
  .team-map {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 80px;
    margin-top: 50px;
    .team-col {
      width: 200px;
      text-align: center;
      .gatsby-image-wrapper {
        height: 200px;
        width: 200px;
        border-radius: 50%;
      }
    }
  }
  .button-cta {
    text-align: center;
    button {
      background-color: #c44c4a;
      color: #fff;
      font-family: "Work Sans";
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      border: none;
      padding: 12px 35px;
      margin-top: 40px;
      &:hover {
        cursor: pointer;
      }
      a {
        text-decoration: none;
        color: #fff
      }
    }
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin-top: 0px;
    margin-bottom: 15px;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    line-height: 24px;
    color: #2b2520;
    margin-top: 20px;
    margin-bottom: 0;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    line-height: 24px;
    color: #2b2520;
    margin-top: 0;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  p,
  ul,
  ol {
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 1.3;
    color: #777c7c;
    margin-bottom: 0;
  }
  ul,
  ol {
    margin-left: 20px;
  }
  @media (max-width: 1200px) {
    .element-border {
      padding: 40px 70px;
    }
    .team-map {
      gap: 30px;
      .team-col {
        width: 170px;
        .gatsby-image-wrapper {
          height: 170px;
          width: 170px;
        }
      }
    }
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
    h4 {
      font-size: 28px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    p,
    ul {
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    .element-border {
      padding: 20px;
    }
    h2 {
      font-size: 36px;
    }
    h4 {
      font-size: 20px;
    }
    ul {
      margin-left: 0;
    }
    p,
    ul {
      font-size: 16px;
      line-height: 1.6;
    }
  }
`

export default ExpertSection
